import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'vui-autocomplete-input-option',
    templateUrl: './autocomplete-input-option.component.html',
    styleUrls: ['./autocomplete-input-option.component.scss']
})
export class AutocompleteInputOptionComponent implements OnInit {
    @Input() public label: string;
    @Input() public value: string;

    constructor() {
    }

    ngOnInit() {
    }

}
